const construirLlave = (empresaId) => `borradorOrdenDeCompra_${empresaId}`;

export function guardarBorradorOrdenDeCompra(empresaId, valores) {
  try {
    window.localStorage.setItem(
      construirLlave(empresaId),
      JSON.stringify({ valores, timestamp: Date.now() })
    );
  } catch (error) {
    console.error("Error al guardar el borrador de la orden de compra:", error);
  }
}

export function leerBorradorOrdenDeCompra(empresaId) {
  try {
    const guardado = window.localStorage.getItem(construirLlave(empresaId));
    if (!guardado) return null;
    return JSON.parse(guardado);
  } catch (error) {
    console.error("Error al leer el borrador de la orden de compra:", error);
    return null;
  }
}

export function borrarBorradorOrdenDeCompra(empresaId) {
  try {
    window.localStorage.removeItem(construirLlave(empresaId));
  } catch (error) {
    console.error("Error al borrar el borrador de la orden de compra:", error);
  }
}
